import TermsPage from './TermsPage';

export default TermsPage;
